// Wire react-plotly.js to the lean dist-min bundle of Plotly.
// Without this, react-plotly.js would try to pull in the full `plotly.js`
// package (several megabytes). plotly.js-dist-min is the ES bundle shipped
// by Plotly with the same JS API.
import createPlotlyComponent from "react-plotly.js/factory";
// @ts-expect-error — plotly.js-dist-min has no bundled types.
import Plotly from "plotly.js-dist-min";

export const Plot = createPlotlyComponent(Plotly);

// Re-export the Plotly module so we can drive `downloadImage` from a
// custom modebar button in `plotlyTheme.ts` — see that file for why
// the default toImage button alone wasn't producing a white background.
export const PlotlyLib = Plotly as unknown as {
  downloadImage: (
    gd: HTMLElement,
    opts: {
      format: "png" | "jpeg" | "svg" | "webp";
      filename: string;
      width: number;
      height: number;
      scale?: number;
      setBackground?: string;
    },
  ) => Promise<string>;
};
